import { useCallback } from 'react'
import { RootState } from 'app/rootReducer';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { addRooms } from './houseSlice';
import { useHistory } from 'react-router-dom';
import logo from '../../app/logo.jpg';



export default function ShowRoom(): JSX.Element{
    // Get reference to the house Slice from the Store
    let house = useSelector(
        (state: RootState) => state.house
    )
    
    const dispatch = useDispatch()
    const amount = house.roomAmount
    let rooms: object[] = Array(amount).fill({})
    rooms = rooms.map((v, i) => (
        newRoom(house.rooms[i])
    ))
    const history = useHistory();
    const Callback = useCallback((val) => history.push(val), [history]);

    function roomInputField(obj: {[key: string]: any}): any{
        return Object.keys(obj).map((v) => (
            v === "elInstall" ? "" 
            : <td> 
                <input 
                    type={v === "Navn" ? "text" : "number"} 
                    placeholder={v}
                    defaultValue={(v === "Navn" || v === "Etasje")
                        ? obj[v] 
                        : obj[v]["amount"]
                    }
                    min={0}
                    onChange={(event) => ((v === "Navn" || v === "Etasje") 
                        ? obj[v] = event.currentTarget.value 
                        : obj[v]["amount"] = event.currentTarget.value === "" ? 0 : parseInt(event.currentTarget.value))
                    }
                /> 
            </td>
        ))
    }

    function newRoom(obj?: any){
        let newObj = {}
        // The first time we initiate the array of all the rooms, it will be undefined.
        // We che check to see if it's undefined or if it should be populated with pre existing values
        newObj = obj === undefined 
                    ? {
                        Navn: "", 
                        Etasje: 0, 
                        rgb: {amount: 0, values: []}, 
                        light: {amount: 0, values: {}}, 
                        heat: {amount: 0, values: []}, 
                        cooling: {amount: 0, values: []}, 
                        sun: {amount: 0, values: []},
                        elInstall: {
                            roomType: 0, 
                            audio: false, 
                            roomSize: 0, 
                            benchSize: 0, 
                            wallSize: 0, 
                            equipmentAmount: 0, 
                            eatingArea: false, 
                            singleStick: 0, 
                            doubleStick: 0, 
                            fourWayStick:0,
                            needAmount: 0,
                            totalAmount: 0,
                            roomName: "",
                        },
                      }
                    : {
                        Navn: obj["Navn"], 
                        Etasje: obj["Etasje"], 
                        rgb: {amount: obj["rgb"]["amount"], values: obj["rgb"]["values"]}, 
                        light: {amount: obj["light"]["amount"], values: obj["light"]["values"]}, 
                        heat: {amount: obj["heat"]["amount"], values: obj["heat"]["values"]},
                        cooling: {amount: obj["cooling"]["amount"], values: obj["cooling"]["values"]},
                        sun: {amount: obj["sun"]["amount"], values: obj["sun"]["values"]},
                        elInstall: {
                            roomType: obj["elInstall"]["roomType"], 
                            audio: obj["elInstall"]["audio"], 
                            roomSize: obj["elInstall"]["roomSize"], 
                            benchSize: obj["elInstall"]["benchSize"], 
                            wallSize: obj["elInstall"]["wallSize"], 
                            equipmentAmount: obj["elInstall"]["equipmentAmount"], 
                            eatingArea: obj["elInstall"]["eatingArea"], 
                            singleStick: obj["elInstall"]["singleStick"], 
                            doubleStick: obj["elInstall"]["doupleStick"], 
                            fourWayStick: obj["elInstall"]["fourWayStick"],
                            needAmount: obj["elInstall"]["needAmount"],
                            totalAmount: obj["elInstall"]["totalAmount"],
                            roomName: obj["elInstall"]["roomName"],
                        },
                    }
        return newObj
    }

    function saveInfo(){
        return new Promise((resolve, reject) => {
            dispatch(addRooms(rooms))
            resolve(true)
        })
        
    }

    async function HandleRouting(goForward: boolean){
        let done = await saveInfo()
        goForward ? (house.el_install ? Callback(`/room/${house.currentRoom}/elInstall`) : Callback('/room/' + house.currentRoom)) : Callback('/')
    }

    console.log(house)
    return(
        <div>
            <div>
                <img src={logo} />
            </div>
            <div className="mainDiv">
                <table id="tblRooms">
                    <thead>
                        <tr>
                            <th>Navn</th>
                            <th>Etasje</th>
                            <th>RGB</th>
                            <th>Lyssone</th>
                            <th>Varmesone</th>
                            <th>Avkjoling</th>
                            <th>Solskjerming</th>
                        </tr>
                    </thead>
                    <tbody>
                        {rooms.map((v) => (
                            <tr>
                                {roomInputField(v)}
                            </tr>
                        ))}
                    </tbody>
                </table>
                <button className="btnTilbake" onClick={() => HandleRouting(false)}>Tilbake</button>
                <button className="btnSave" onClick={() => HandleRouting(true)}>Lagre & Neste</button>
            </div>
            
        </div>
    )
}